import React from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';
import './InputFieldsSmallComponent.css';
import InfoBar from '../InfoBars';

interface InputFieldProps {
  placeholder: string;
  inputType?: 'general' | 'entered' | 'error' | 'success' | 'disabled';
  type: string; //text | email | password |
  isDisabled: boolean;
  className?: string;
  dataTestId?:string;
  labelName?: string;
  required?: boolean;
  onChange: (value: string) => void;
  value?: string;
  maximumLength?: number ;
  inputId?:any;
  errorMessage?:string;
  disablePastDates?:boolean;
  maxDate?:string;
  minDate?:string;
}
const InputFieldsComponent = ({
  inputType = 'general',
  placeholder,
  type,
  isDisabled,
  className,
  labelName,
  dataTestId,
  required,
  onChange,
  value,
  maximumLength,
  inputId,
  errorMessage,
  disablePastDates,
  maxDate,
  minDate
}: InputFieldProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };
  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === 'number' && maximumLength !== undefined && e.target.value.length > maximumLength) {
      e.target.value = e.target.value.slice(0, maximumLength);
    }
    if (type === 'text') {
      if (className === 'lattitude' || className === 'longitude') {
        const regex = /^(-?\d{0,3}\.\d*),(-?\d{0,3}\.\d*)$/;
        if (!regex.test(e.target.value)) {
          const lastChar = e.target.value[e.target.value.length - 1];
          if (!/[\d.,-]/.test(lastChar)) {
            e.target.value = e.target.value.slice(0, -1);
          }
        }
       }
      else if (className === 'pincode') {
        if (!/^\d{0,6}$/.test(e.target.value)) {
          e.target.value = e.target.value.slice(0, -1);
        }
      }
      else if (className === 'sanctionedbed_count' || className === 'functionalbed_count' ) {
        if (!/^\d{0,4}$/.test(e.target.value)) {
          e.target.value = e.target.value.slice(0, -1);
        }
      }
    }
  };
  const getCurrentDate =() =>{
    return new Date().toISOString().slice(0,10);
  }
  
  return (
    <div className='input_fields_small'>
    <div className={`input-field-container  ${className}`}>
      {labelName && (
        <label
          className={`label-name-from-parent ${required && 'yes'} ${isDisabled}`}
        >
          {labelName}
        </label>
      )}
      <InputGroup
        className={` input-field-group input-field-group-${inputType}`}
      >
        <FormControl
          placeholder={placeholder}
          aria-label="Search"
          className={`text-bar-input ${isDisabled} ${type === 'number' ? 'no-spinner' : ''}`}
          type={type}
          data-testid={dataTestId}
          disabled={isDisabled}
          onChange={handleChange}
          value={value}
          maxLength={maximumLength}
          id={inputId}
          onInput={handleInput}
          min={type==='date'  ? minDate : undefined}
          max={type==='date' ? maxDate : undefined}        />
      </InputGroup>
      <div className="input_field_infoBars">
        {inputType === 'success' ? (
          <InfoBar
            variant="success"
            message={errorMessage?errorMessage:'Success'}
            className="input_field_class"
          />
        ) : (
          ''
        )}
        {inputType === 'error' && errorMessage ? (
          <InfoBar
            variant="danger"
            message={errorMessage}
            className="input_field_class"
          />
        ) : null}
      </div>
    </div>
    </div>
  );
};
export default InputFieldsComponent;
